export default __webpack_public_path__ + "static/media/2010.6c22079b.png";